import { useTranslation } from 'react-i18next'
import { formatNumbers } from 'core/helpers/format-numbers'
import cn from 'classnames'
import { stageSelector } from 'models/battle/selectors'
import { useDispatch, useSelector } from 'react-redux'
import { stageType } from '../constants/stageType'
import { useEffect, useState } from 'react'
import { battleService } from '../../../core/services'
import { useAuthContext } from '../../../core/providers/AuthProvider'
import c from './assets/sass/players.module.scss'
import { setStage } from 'models/battle'

import emptyAvatar from './assets/images/empty-user.png'

export const Players = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const stage = useSelector(stageSelector)
    const [showOpponent, setShowOpponent] = useState(false)
    const [opponent, setOpponent] = useState(null)
    const { user } = useAuthContext()

    useEffect(() => {
        let timer = null

        if (stage === stageType.waiting) {
            setShowOpponent(false)
            const poll = async () => {
                try {
                    const res = await battleService.getCurrentBattle()
                    const p = res?.battle?.players || []
                    const opp = p
                        .map((x) => x.user)
                        .find((u) => String(u?.id) !== String(user?.id))
                    if (opp) {
                        setOpponent(opp)
                        setShowOpponent(true)
                        dispatch(setStage(stageType.rolling))
                        return
                    }
                } catch {}
                timer = setTimeout(poll, 1000)
            }
            poll()
        } else if (
            stage === stageType.rolling ||
            stage === stageType.finished
        ) {
            const loadOpp = async () => {
                try {
                    const res = await battleService.getCurrentBattle()
                    const p = res?.battle?.players || []
                    const opp = p
                        .map((x) => x.user)
                        .find((u) => String(u?.id) !== String(user?.id))
                    if (opp && !opponent) {
                        setOpponent(opp)
                        setShowOpponent(true)
                    }
                } catch {}
            }
            if (!opponent || !showOpponent) {
                loadOpp()
            }
        }

        return () => {
            if (timer) {
                clearTimeout(timer)
            }
        }
    }, [stage, dispatch, user?.id, opponent, showOpponent])

    const getOpponent = () => {
        if (
            (showOpponent && opponent) ||
            (opponent &&
                (stage === stageType.rolling || stage === stageType.finished))
        ) {
            return (
                <div className={c.player}>
                    <img
                        src={opponent.photoUrl || '/images/avatar-02.png'}
                        alt="Player"
                    />
                    <div className={c.info}>
                        <span className={c.nickName}>
                            {t('battle.players.opponent')}
                        </span>
                        <span className={c.coin}></span>
                    </div>
                </div>
            )
        }

        return (
            <div className={cn(c.player, c.empty)}>
                <img src={emptyAvatar} alt="Player" />
                <div className={c.info}>
                    <span className={c.nickName}>
                        {t('battle.players.opponent')}
                    </span>
                </div>
            </div>
        )
    }

    return (
        <div className={c.component}>
            <div className={c.player}>
                <img
                    src={user?.photoUrl || '/images/avatar.png'}
                    alt="Player"
                />
                <div className={c.info}>
                    <span className={c.nickName}>
                        {t('battle.players.you')}
                    </span>
                    <span className={c.coin}>
                        {formatNumbers(user?.balance || 0)}
                    </span>
                </div>
            </div>
            {getOpponent()}
        </div>
    )
}
